import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.categoria
    ? _c(
        "div",
        [
          _vm.lista.length > 0
            ? _c(VRow, { staticClass: "mt-8", attrs: { dense: "" } }, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                  },
                  [_vm._v(" " + _vm._s(_vm.titulo) + " ")]
                ),
              ])
            : _vm._e(),
          _c(
            VRow,
            { staticClass: "mt-0", attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VCard,
                    { attrs: { flat: "" } },
                    [
                      _c(
                        VCardText,
                        [
                          _vm.lista.length > 0
                            ? _c(
                                VRow,
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(VAutocomplete, {
                                        staticClass: "mr-4",
                                        attrs: {
                                          items: _vm.listaAreas,
                                          "prepend-icon": _vm.icone,
                                          rules: [
                                            () =>
                                              _vm.areasSelecionadas.length <=
                                                _vm.maximoAreas ||
                                              `Informe no máximo ${_vm.maximoAreas} áreas`,
                                          ],
                                          "search-input": _vm.search,
                                          chips: "",
                                          color: "primary",
                                          counter: "",
                                          "deletable-chips": "",
                                          "item-text": "nome",
                                          label: "Digite ou selecione as áreas",
                                          placeholder:
                                            "Digite para pesquisar...",
                                          multiple: "",
                                          outlined: "",
                                          required: "",
                                          "return-object": "",
                                          "validate-on-change": "",
                                        },
                                        on: {
                                          "update:searchInput": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          "update:search-input": function (
                                            $event
                                          ) {
                                            _vm.search = $event
                                          },
                                          change: function ($event) {
                                            _vm.select()
                                            _vm.search = ""
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function (data) {
                                                return [
                                                  _c(
                                                    VChip,
                                                    {
                                                      staticClass:
                                                        "chip--select-multi",
                                                      attrs: {
                                                        "input-value":
                                                          data.selected,
                                                        close: "",
                                                        color: "secondary",
                                                        search: "",
                                                        "text-color": "white",
                                                      },
                                                      on: {
                                                        "click:close":
                                                          function ($event) {
                                                            return _vm.remove(
                                                              data.item
                                                            )
                                                          },
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            data.item.nome
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                            {
                                              key: "no-data",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    VListItem,
                                                    [
                                                      _c(
                                                        VListItemContent,
                                                        [
                                                          _c(
                                                            VListItemTitle,
                                                            [
                                                              _vm._v(
                                                                " A área "
                                                              ),
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticClass:
                                                                    "secondary--text",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.search
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(
                                                                " não foi encontrada. "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                            {
                                              key: "counter",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    VChip,
                                                    {
                                                      attrs: {
                                                        "text-color":
                                                          "secondary",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VAvatar,
                                                        {
                                                          attrs: {
                                                            color: "secondary",
                                                            left: "",
                                                            "text-color":
                                                              "white",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "white--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm
                                                                    .areasSelecionadas
                                                                    .length
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(
                                                        " áreas selecionadas "
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          3434069375
                                        ),
                                        model: {
                                          value: _vm.areasSelecionadas,
                                          callback: function ($$v) {
                                            _vm.areasSelecionadas = $$v
                                          },
                                          expression: "areasSelecionadas",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm.permiteCriarArea
                                    ? _c(
                                        VCol,
                                        { attrs: { cols: "12", md: "1" } },
                                        [
                                          _c(
                                            VMenu,
                                            {
                                              attrs: {
                                                "close-on-content-click": false,
                                                "nudge-width": 500,
                                                "offset-y": "",
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on: menu,
                                                    }) {
                                                      return [
                                                        _c(
                                                          VTooltip,
                                                          {
                                                            attrs: { top: "" },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "activator",
                                                                  fn: function ({
                                                                    on: tooltip,
                                                                  }) {
                                                                    return [
                                                                      _c(
                                                                        VBtn,
                                                                        _vm._g(
                                                                          {
                                                                            attrs:
                                                                              {
                                                                                color:
                                                                                  "secondary",
                                                                                dark: "",
                                                                                fab: "",
                                                                                small:
                                                                                  "",
                                                                              },
                                                                          },
                                                                          {
                                                                            ...tooltip,
                                                                            ...menu,
                                                                          }
                                                                        ),
                                                                        [
                                                                          _c(
                                                                            VIcon,
                                                                            [
                                                                              _vm._v(
                                                                                "add"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c("span", [
                                                              _vm._v(
                                                                "Clique no botão para adicionar uma nova área"
                                                              ),
                                                            ]),
                                                          ]
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                3976644025
                                              ),
                                              model: {
                                                value:
                                                  _vm.dialogAdicionarArea
                                                    .visibilidade,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.dialogAdicionarArea,
                                                    "visibilidade",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "dialogAdicionarArea.visibilidade",
                                              },
                                            },
                                            [
                                              _c(
                                                VCard,
                                                { staticClass: "pa-5" },
                                                [
                                                  _c(
                                                    VCardTitle,
                                                    [
                                                      _c(
                                                        VRow,
                                                        {
                                                          staticClass:
                                                            "d-flex flex-column text-lg-center",
                                                        },
                                                        [
                                                          _c(
                                                            "h5",
                                                            {
                                                              staticClass:
                                                                "headline primary--text text-no-wrap",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Adicionar Área de " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .categoria
                                                                      .nome
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "subtitle-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Informe o nome da Área"
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VCardText,
                                                    [
                                                      _c(
                                                        VForm,
                                                        {
                                                          ref: "formArea",
                                                          on: {
                                                            submit: function (
                                                              $event
                                                            ) {
                                                              $event.preventDefault()
                                                              return _vm.adicionarArea()
                                                            },
                                                          },
                                                          model: {
                                                            value:
                                                              _vm
                                                                .dialogAdicionarArea
                                                                .valid,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.dialogAdicionarArea,
                                                                "valid",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "dialogAdicionarArea.valid",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            VRow,
                                                            [
                                                              _c(
                                                                VTextField,
                                                                {
                                                                  attrs: {
                                                                    rules: [
                                                                      (n) =>
                                                                        !!n ||
                                                                        "O nome da área não pode ser vazio",
                                                                      (n) =>
                                                                        !_vm.areaJaExiste(
                                                                          n
                                                                        ) ||
                                                                        "Este nome de área já existe",
                                                                    ],
                                                                    label:
                                                                      "Nome da Área",
                                                                    required:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.area
                                                                        .nome,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.area,
                                                                          "nome",
                                                                          typeof $$v ===
                                                                            "string"
                                                                            ? $$v.trim()
                                                                            : $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "area.nome",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    VCardActions,
                                                    [
                                                      _c(
                                                        VRow,
                                                        {
                                                          staticClass:
                                                            "justify-end mr-4",
                                                        },
                                                        [
                                                          _c(
                                                            VBtn,
                                                            {
                                                              staticClass:
                                                                "mr-2",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.area
                                                                    .nome ===
                                                                  "",
                                                                color:
                                                                  "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.adicionarArea()
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Adicionar "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            VBtn,
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                outlined: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    _vm.dialogAdicionarArea.visibilidade = false
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " Cancelar "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm.mostrarInstrutor
                            ? _c(
                                VRow,
                                {
                                  staticClass: "justify-end",
                                  attrs: { dense: "" },
                                },
                                [
                                  _c(
                                    VCol,
                                    [
                                      _c(
                                        VCard,
                                        { attrs: { flat: "" } },
                                        [
                                          _c(
                                            VCardText,
                                            [
                                              _c(
                                                VRow,
                                                { attrs: { dense: "" } },
                                                [
                                                  _c(
                                                    VCol,
                                                    [
                                                      _c("h4", [
                                                        _vm._v(
                                                          " Você tem interesse em ser "
                                                        ),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "secondary--text",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Instrutor de " +
                                                                _vm._s(
                                                                  _vm.categoria
                                                                    .nome
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v("? "),
                                                      ]),
                                                      _c(
                                                        VRadioGroup,
                                                        {
                                                          attrs: { row: "" },
                                                          on: {
                                                            change: _vm.confirm,
                                                          },
                                                          model: {
                                                            value: _vm.opcao,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.opcao = $$v
                                                            },
                                                            expression: "opcao",
                                                          },
                                                        },
                                                        [
                                                          _c(VRadio, {
                                                            attrs: {
                                                              value: true,
                                                              label: "Sim",
                                                            },
                                                          }),
                                                          _c(VRadio, {
                                                            attrs: {
                                                              value: false,
                                                              label: "Não",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.opcao
                                                ? _c(
                                                    VRow,
                                                    { attrs: { dense: "" } },
                                                    [
                                                      _c(
                                                        VCol,
                                                        [
                                                          _c(
                                                            "curso-instrutor-form",
                                                            {
                                                              attrs: {
                                                                maximo:
                                                                  _vm.maximoCursos,
                                                                tipo: _vm.tipo,
                                                                titulo: `Indique o(s) curso(s) (Máximo ${_vm.maximoCursos})`,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }